import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import Card from '../../../components/Card'
import { OpportunitiesService } from '../../../service/contacts-service'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SearchComponent from '../../../components/partials/backend/Search/SearchComponent'
import SortToggle from '../../../components/partials/backend/SortToggle/SortToggle'
import PaginationComponent from '../../../components/partials/backend/Pagination/PaginationComponent'
import axios from 'axios'

const Opportunity = () => {
  const service = new OpportunitiesService()
  const location = useLocation()
  const history = useHistory()
  const [opportunities, setOpportunities] = useState([])
  const [paginationObject, setPaginationObject] = useState(null)
  const { config } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [sort, setSort] = useState("")
  const [nPages, setPage] = useState(0)
  const [page, setCurrentPage] = useState(1)
  const [numberOfItem, setNumberOfItem] = useState(0)

  async function fetchList(url = null) {
    setLoading(true)
    try {
      let response
      
      if (url) {
        // If URL is provided (from pagination), use it directly
        response = await axios.get(url, { withCredentials: true }).then(r => r.data)
      } else {
        // Otherwise, build params for initial load
        const params = {}
        
        // Add search parameter
        if (search && search.trim()) {
          params.search = search.trim()
        }
        
        // Add sort parameter
        if (sort && sort.trim()) {
          params.sort = sort
        }
        
        // Add page parameter
        if (page) {
          params.page = page
        }
        
        response = await service.list(params)
      }
      
      if (!response.error) {
        setOpportunities(response.data || [])
        if (response.pagination) {
          setPaginationObject(response.pagination)
          setPage(response.pagination.n_pages)
          setCurrentPage(response.pagination.current_page)
          setNumberOfItem(response.pagination.n_items)
        }
      }
    } catch (error) {
      console.error('Error fetching opportunities:', error)
    } finally {
      setLoading(false)
    }
  }

  // Get badge color based on state
  function getStateBadgeColor(state) {
    if (!state) return 'bg-secondary'
    
    const stateValue = typeof state === 'object' ? state.state : state
    
    switch (stateValue) {
      case '1':
        return 'bg-primary'
      case '13':
        return 'bg-warning'
      case '12':
      case 'vinto':
        return 'bg-success'
      case '10':
      case 'archiviato':
        return 'bg-secondary'
      default:
        return 'bg-info'
    }
  }

  // Get state display name
  function getStateName(state) {
    if (!state) return 'N/A'
    return typeof state === 'object' ? (state.name || state.state || 'N/A') : state
  }

  useEffect(() => {
    fetchList()
  }, [search, sort, page])

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="font-weight-bold">Opportunità</h4>
              </div>
              <div className="create-workform">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="modal-product-search d-flex">
                    {/* Search by opportunity name */}
                    <div className="mr-3 position-relative">
                      <SearchComponent 
                        search={search} 
                        setSearch={setSearch} 
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col lg="12">
                <Card className="card-block card-stretch">
                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <table className="table data-table mb-0">
                        <thead className="table-color-heading">
                          <tr className="text-light">
                            <th scope="col" style={{ width: "18%" }}>
                              <label className="text-muted m-0">Nome Opportunità</label>
                              <SortToggle 
                                field="name" 
                                setSort={setSort} 
                                fetchList={fetchList} 
                                setCurrentPage={setCurrentPage} 
                                id={1}
                              />
                            </th>
                            <th scope="col" style={{ width: "13%" }}>
                              <label className="text-muted m-0">Contatto</label>
                            </th>
                            <th scope="col" style={{ width: "13%" }}>
                              <label className="text-muted m-0">Prodotto</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Istituto</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Campagna</label>
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              <label className="text-muted m-0">Stato</label>
                              <SortToggle 
                                field="state" 
                                setSort={setSort} 
                                fetchList={fetchList} 
                                setCurrentPage={setCurrentPage} 
                                id={2}
                              />
                            </th>
                            <th scope="col" style={{ width: "13%" }}>
                              <label className="text-muted m-0">Data Creazione</label>
                              <SortToggle 
                                field="creation_date" 
                                setSort={setSort} 
                                fetchList={fetchList} 
                                setCurrentPage={setCurrentPage} 
                                id={3}
                              />
                            </th>
                            <th scope="col" style={{ width: "13%" }}>
                              <label className="text-muted m-0">Azioni</label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr style={{ height: "100px", paddingTop: "10px" }}>
                              <td colSpan="8">
                                <p className="loader"></p>
                              </td>
                            </tr>
                          ) : (opportunities || []).length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center text-muted py-5">
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="mb-3">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                                <div>Nessuna opportunità trovata</div>
                              </td>
                            </tr>
                          ) : (
                            (opportunities || []).map((opp, index) => (
                              <tr key={opp.id || index} className="white-space-no-wrap">
                                <td>
                                  <strong>{opp.name || 'N/A'}</strong>
                                </td>
                                <td>
                                  {opp.contact ? (
                                    <span>
                                      {opp.contact.name} {opp.contact.surname}
                                    </span>
                                  ) : (
                                    <span className="text-muted">N/A</span>
                                  )}
                                </td>
                                <td>{opp.product?.name || 'N/A'}</td>
                                <td>{opp.institute?.name || '-'}</td>
                                <td>{opp.campaign?.name || 'N/A'}</td>
                                <td>
                                  <span className={`badge ${getStateBadgeColor(opp.state)} rounded rounded-pill px-2 py-1`}>
                                    {getStateName(opp.state)}
                                  </span>
                                </td>
                                <td>
                                  <small className="text-muted">
                                    {opp.creation_date 
                                      ? new Date(opp.creation_date).toLocaleDateString('it-IT')
                                      : 'N/A'}
                                  </small>
                                </td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center">
                                    {/* View link - redirect to contact */}
                                    {opp.contact ? (
                                      <Link 
                                        to={{ 
                                          pathname: `/contact-view/${opp.contact.id}`, 
                                          state: {
                                            fromOpportunities: true,
                                            opportunitySort: sort,
                                            opportunitySearch: search,
                                            opportunityPage: page
                                          } 
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="text-secondary mx-4"
                                          width="20"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                        </svg>
                                      </Link>
                                    ) : (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="text-muted mx-4"
                                        width="20"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        style={{ opacity: 0.5 }}
                                      >
                                        <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                      </svg>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    {paginationObject ? (
                      <PaginationComponent 
                        fetchList={fetchList} 
                        paginationObject={paginationObject} 
                        nPages={nPages} 
                        page={page} 
                        numberOfItem={numberOfItem} 
                      />
                    ) : null}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Opportunity
